import { RmsAccountSelection } from '@/ui/features/badging/badging-customizations/badge-create/types';
import { ManageBadgesPanelProps } from '@juvare/badging/ui/features/badge-management/ManageBadgesPanel';
import { AccountSelection } from '@juvare/badging/ui/features/badge-management/components/BadgeAccountsSelectionPanel/types';

export const adjustAccountSelectionChanged: NonNullable<ManageBadgesPanelProps['adjustAccountSelectionChanged']> = (
    accountSelection: AccountSelection,
) => {
    const rmsAccountSelection = accountSelection as RmsAccountSelection;

    // preselect organization if there is only one
    if (!rmsAccountSelection.options.organizationId && rmsAccountSelection.account.orgMembership.length === 1) {
        rmsAccountSelection.options.organizationId = rmsAccountSelection.account.orgMembership[0];
    }

    // preselect occupation if there is only one
    if (!rmsAccountSelection.options.occupationId && rmsAccountSelection.account.occupationIds?.length === 1) {
        rmsAccountSelection.options.occupationId = rmsAccountSelection.account.occupationIds[0];
    }

    return rmsAccountSelection;
};
